<div class="wrapper-container">
  <cw-breadcrumbs *ngIf="breadcrumbsFormData && breadcrumbsFormData.length > 0"
    [jsonFormData]="breadcrumbsFormData"></cw-breadcrumbs>
  <mat-icon class="close-card text-secondary f-24 pointer" *ngIf="!data.action_buttons?.restrictCloseIcon"
    mat-dialog-close>cancel</mat-icon>
  <h5 *ngIf="data?.addTable" class="text-secondary">{{addtable_Pagination}}</h5>
</div>
<div>
  <div class="pb-3">
    <h2 class=" mb-0 fw-500 text-primary {{
            data && data.header_class ? data.header_class : ''
          }} align-center" *ngIf="data?.header">
      {{ data.header }}
    </h2>
    <h5 class="{{
                    data && data.sub_header_class ? data.sub_header_class : 'm-0 fw-500 text-secondary f-14'
                  }}" *ngIf="data?.sub_header">
      <div [innerHTML]="data.sub_header"></div>
    </h5>
  </div>
  <!--Query Details Section starts-->
  <div class="block-1 pt-7" *ngIf="data.query_details && data?.query_details?.edit_name">
    <div class="grid-item m-auto">
      <p class="m-0 f-14 text-secondary w-100">
        <cw-textbox [jsonFormData]="queryName" [parentForm]="paramForm">
        </cw-textbox>
      </p>
    </div>
  </div>
  <div class="block-1 pt-7" *ngIf="
        data.query_details &&
        ((data.query_details.tag && data.query_details.tag.length > 0) ||
          data?.query_details?.name)
      ">
    <div *ngIf="data?.query_details?.name" class="grid-item">
      <p class="m-0 f-14 text-secondary">
        <span class="fw-500 text-primary mt-0">Query Name:</span><br />
        {{ data.query_details.name | titlecase }}
      </p>
    </div>
    <div class="grid-item" *ngIf="data.query_details.tag && data.query_details.tag.length > 0">
      <p class="m-0 f-14 text-secondary">
        <span class="fw-500 text-primary mt-0">Tags:</span><br />
        <span *ngFor="let item of data?.query_details?.tag; let i = index" class="query-tag">{{ item }}
        </span>
      </p>
    </div>
  </div>
  <div class="block-1 pt-7" *ngIf="data.query_details">
    <div class="grid-item m-auto">
      <p class="m-0 f-14 text-secondary" *ngIf="data?.query_details?.description">
        <span class="fw-500 text-primary mt-0">Query Description:<br /></span>
        {{ data.query_details.description | titlecase }}
      </p>
    </div>
  </div>
  <!--Query Details Section Ends-->

  <!--Query Params Section starts-->
  <div class="block-1 pt-7" *ngIf="data.query_params">
    <form [formGroup]="paramForm">
      <div class="grid-item m-auto" *ngIf="data?.query_params?.param_name">
        <div class="block-1" *ngFor="let input of data.query_params.param_name; let i = index">
          <div class="grid-item">
            <cw-textbox [jsonFormData]="formJson[i]" [parentForm]="paramForm"></cw-textbox>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!--Query Params Section Ends-->

  <!--Query Properties Section starts-->
  <div class="block-1 pt-7 container queryProp" *ngIf="data.query_properties">
    <div class="block-2">
      <div class="grid-item query-name">
        <cw-textbox [jsonFormData]="queryTitle" [parentForm]="paramForm"></cw-textbox>
      </div>
      <div class="grid-item query-des">
        <cw-textbox [jsonFormData]="queryDescription" [parentForm]="paramForm"></cw-textbox>
      </div>
    </div>
    <div class="grid-item query-keyword">
      <cw-chips [jsonFormData]="queryTags" [parentForm]="paramForm"
        (enteredValueEvent)="getSelectedQueryTags($event)"></cw-chips>
    </div>
  </div>
  <!--Query Properties Section Ends-->

  <!--Add Table Section starts-->

  <div class="container addTable" *ngIf="data.addTable">
    <div class="container" *ngIf="addtable_landingPage">
      <div>
        <cw-textbox [jsonFormData]="primaryTableSearch" [parentForm]="paramForm"
          (onClick)="searchTables($event)"></cw-textbox>
      </div>
      <div>
        <mat-list class="scroll">
          <cw-radio-button-group [refresh]="reloadTemplateOption" [parentForm]="paramForm"
            [jsonFormData]="primaryTableRadio" (selectedValueEvent)="getSelectedTemplateData($event)">
          </cw-radio-button-group>
        </mat-list>
      </div>
    </div>
  </div>

  <div class="block-1 pt-7" *ngIf="data.addTable && !addtable_landingPage">
    <p class="m-0 f-14 text-secondary w-100">
      <cw-textbox [jsonFormData]="tableAlias" [parentForm]="paramForm">
      </cw-textbox>
    </p>
  </div>

  <!--Add Table Section Ends-->

  <!--Add Column Join Section Starts-->
  <div class="container addTable" *ngIf=" keyword =='popupColumnJoin'">
    <mat-list class="scroll">
      <cw-radio-button-group [parentForm]="paramForm" [jsonFormData]="joinColumnsRadio"
        (selectedValueEvent)="setSelectedColumnToJoin($event)">
      </cw-radio-button-group>
    </mat-list>
  </div>

  <div class="block-1 pt-7 pb-3" *ngIf=" keyword =='popupColumnJoin'">
    <div class="grid-item m-auto">
      <p class="m-0 f-14 text-secondary w-100">
        <cw-textbox [jsonFormData]="joinColumnsTableAlias" [parentForm]="paramForm">
        </cw-textbox>
      </p>
    </div>
  </div>
  <mat-error *ngIf="proceedButton.disabled">{{getColumnJoinPopupError()}} </mat-error>

  <!--Add Column Join Section Ends-->

  <!--User Details Section starts-->
  <div class="block-1 pt-7" *ngIf="data.user_detail">
    <div class="grid-item m-auto">
      <img *ngIf="data?.user_detail?.imagesrc" width="100px" class="popup-image" height="100px"
        [src]="data.user_detail.imagesrc" onerror="this.src='assets/images/no-picture.png'" alt="User-Image" />
    </div>
    <div class="grid-item m-auto">
      <p class="m-0 f-14 text-secondary" *ngIf="data?.user_detail?.user_name">
        <span class="{{ data.user_detail.label_class }}">User:</span>
        {{ data.user_detail.user_name | titlecase }}
      </p>
      <p class="m-0 f-14 text-secondary" *ngIf="data?.user_detail?.query_name">
        <span class="{{ data.user_detail.label_class }}">Query Name:</span>
        {{ data.user_detail.query_name }}
      </p>
      <p class="m-0 f-14 text-secondary" *ngIf="data?.user_detail?.query_id">
        <span class="{{ data.user_detail.label_class }}">Query ID:</span>
        {{ data.user_detail.query_id }}
      </p>
      <p class="m-0 f-14 text-secondary" *ngIf="data.user_detail?.accessed_time">
        <span class="{{ data.user_detail.label_class }}">Accessed:</span>
        <span class="text-primary">
          {{ data.user_detail.accessed_time }}</span>
      </p>
    </div>
  </div>
  <!--User Details Section Ends-->
  <!-- QueryParam Create New/Existing Starts-->

  <div class="block-1 pt-7" *ngIf="data?.new_existing_queryParam">
    <form [formGroup]="paramForm">
      <div class="grid-item m-auto" *ngIf="data?.new_existing_queryParam">
        <div class="container">
          <div class="grid-item">
            <cw-radio-button-group [parentForm]="paramForm" [jsonFormData]="queryParamTypeRadio"
              (selectedValueEvent)="getSelectedQueryParamRadioData($event)">
            </cw-radio-button-group>
          </div>
          <ng-container *ngIf="this.queryParamTypeRadio.defaultSelectedValue === 'New'">
            <div class="block-1 mb-30">
              <div class="grid-item">
                <cw-textbox [jsonFormData]="newParameterName" [parentForm]="paramForm">
                </cw-textbox>
              </div>
            </div>
            <div class="grid-item">
              <cw-drop-down [jsonFormData]="dataTypeParameter" [parentForm]="paramForm">
              </cw-drop-down>
            </div>
          </ng-container>

          <ng-container *ngIf="
                this.queryParamTypeRadio.defaultSelectedValue === 'Existing'
              ">
            <div class="grid-item">
              <cw-drop-down (selectedValueEvent)="getExistingParamData($event)" [jsonFormData]="existingParameterName"
                [parentForm]="paramForm">
              </cw-drop-down>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>

  <!-- QueryParam Create New/Existing Ends -->

  <!-- Switch table Section Starts-->
  <div class="block-1 pt-7" *ngIf="data.switchQuery && data?.switchQuery?.isShow">
    <p class="m-0 f-20 text-secondary align-center">
      <span><b>Current:</b></span>
      {{ data.switchQuery.queryTitle | titlecase }}
    </p>
  </div>

  <!-- Switch table section ends -->
  <!-- Switch tab/ Query table Section Starts -->
  <div class="block-1 pt-7" *ngIf="data?.switchTabQueryTable && data?.switchTabQueryTable?.isShow">
    <p class="m-0 f-20 text-secondary align-center">
      <span><b>{{ data.switchTabQueryTable?.currentItemPrefix}}</b></span>
      {{ data.switchTabQueryTable?.currentItem}}
    </p>
    <p class="m-0 f-20 text-secondary align-center">
      <span><b>{{ data.switchTabQueryTable?.switchToItemPrefix}}</b></span>
      {{ data.switchTabQueryTable?.switchToItem}}
    </p>
  </div>
  <!-- Switch tab/ Query table Section Ends -->

  <!-- Sub-Query forms and table start -->
  <!-- Need to remove this very soon -->
  <div class="container" *ngIf="data.subQuery">
    <div class="right">
      <div class="new-query-btn">
        <cw-button [jsonFormData]="subQueryNewQueryButton" (onClick)="subQueryNewQueryButtonAction()"></cw-button>
      </div>
      <div>
        <cw-textbox [jsonFormData]="subQueryFormQueryId" [parentForm]="subQueryForm"
          (onClick)="searchTables($event)"></cw-textbox>
      </div>
      <div>
        <cw-textbox [jsonFormData]="subQueryFormQueryName" [parentForm]="subQueryForm"
          (onClick)="searchTables($event)"></cw-textbox>
      </div>
      <div>
        <cw-textbox [jsonFormData]="subQueryFormUsesTable" [parentForm]="subQueryForm"
          (onClick)="searchTables($event)"></cw-textbox>
      </div>
      <div>
        <cw-textbox [jsonFormData]="subQueryFormQueryDescription" [parentForm]="subQueryForm"
          (onClick)="searchTables($event)"></cw-textbox>
      </div>
      <div class="new-query-btn">
        <cw-button [jsonFormData]="subQuerySearchButton" (click)="searchSubquery(1,true)"></cw-button>
      </div>
      <cw-image *ngIf="data.subQuery.querySearched && this.subQueryResult.length === 0"
        [jsonFormData]="noResultFoundimageData"></cw-image>
      <div *ngIf="!subquery_IsResultEmpty && subquery_Refresh">
        <cw-table [jsonFormData]="subQueryTable" (selectedActionEvent)="subqueryTableEvent($event)"
          (sortChangeOutput)="sortChangeEvent($event)">
          <div class="pt-2 load-btn">
            <cw-button *ngIf="data.subQuery.enableLoadMoreButton" [jsonFormData]="loadMoreButton"
              (click)="searchSubquery((this.subquery_PageNo = this.subquery_PageNo + 1),false)"></cw-button>
          </div>
        </cw-table>
      </div>
    </div>
  </div>
  <!-- Sub-Query forms and table end -->

  <!-- List-Lookup forms and table start -->
  <div class="container" *ngIf="data.listLookup">
    <div class="container">
      <div>
        <cw-textbox [jsonFormData]="listLookupId" [parentForm]="listLookupForm"></cw-textbox>
      </div>
      <div>
        <cw-textbox [jsonFormData]="listLookupName" [parentForm]="listLookupForm"></cw-textbox>
      </div>
      <div class="list-search-btn">
        <cw-button [jsonFormData]="listLookupButton" (click)="listLookup()"></cw-button>
      </div>
    </div>
    <div class="list-table">
      <div class="div-list-scroll list-table-right" *ngIf="listLookup_IsSearched">
        <cw-table [jsonFormData]="listLookupTable" (selectedActionEvent)="listSelectedEvent($event)">
          <div class="pt-2 no-list">
            <button *ngIf="listLookupResult.length === 0" style="width: fit-content !important" mat-icon-button>
              <mat-icon fontSet="fa">
              </mat-icon>
              No lists found.
            </button>
          </div>
        </cw-table>
      </div>
      <div class="div-list-scroll" *ngIf="listItemLookup_IsSearched">
        <cw-table [jsonFormData]="listItemLookupTable" (selectedRowsData)="onSelectedData($event)">
          <div class="pt-2 no-list">
            <button *ngIf="listItemLookupResult.length === 0" style="width: fit-content !important" mat-icon-button>
              <mat-icon fontSet="fa">
              </mat-icon>
              No listitems found.
            </button>
          </div>
        </cw-table>
      </div>
    </div>
  </div>
  <!-- List-Lookup forms and table end -->


  <div class="container">
    <div *ngIf="data?.message_title">
      <p class=" f-14 fw-500 text-secondary mb-0 {{
            data && data.message_title_class ? data.message_title_class : ''
          }}">
        {{ data.message_title }}
      </p>
    </div>
    <div *ngIf="data?.message">
      <h4 class="fw-500 text-primary mt-0 {{
          data && data.message_class ? data.message_class : ''
        }}">
        {{ data.message }}
      </h4>
    </div>
    <div *ngIf="data?.message_footer">
      <h4 class="fw-700 text-primary mt-0 {{
            data && data.message_footer_class ? data.message_footer_class : ''
          }}">
        {{ data.message_footer }}
      </h4>
    </div>
    <div class="baseline-button">
      <div class="align-center " *ngIf="data?.action_buttons?.ok_button2">
        <cw-button [jsonFormData]="proceedButton2" (onClick)="proceedMethod2()"></cw-button>
      </div>
      <div class="align-center confirm-btn" *ngIf="data?.action_buttons?.ok_button && proceedButton.label !=='' ">
        <cw-button (onClick)="proceedMethod()" [jsonFormData]="proceedButton"></cw-button>
      </div>
      <div class="cancel-btn align-center" *ngIf="data?.action_buttons?.cancel_button">
        <cw-button [jsonFormData]="closePopupButton" mat-dialog-close *ngIf="addtable_landingPage"></cw-button>
        <cw-button [jsonFormData]="previousButton" (onClick)="previousButtonAction()"
          *ngIf="!addtable_landingPage"></cw-button>
      </div>
    </div>
  </div>
</div>